// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-upload-box {
    /*background-color: #b9a190;*/
    background-color: #4a5568;
    /* background-color: #e07a5f; /* Warm Coral */
    /* background-color: #2b6cb0; /* Steel Blue */
    color: #fff;
    border: none;
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    width: fit-content;
    max-width: 250px;
  }
  
  .btn-upload-box:hover {
    /*background-color: #a48779;*/
    background-color: #2d3748;
    /* background-color: #c35c46; /* Darker Coral */
   /*  background-color: #2c5282; /* Deep Blue */
  }`, "",{"version":3,"sources":["webpack://./src/Components/MainSection/ImportBox/ImportBox.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,6CAA6C;IAC7C,6CAA6C;IAC7C,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,+CAA+C;GAChD,6CAA6C;EAC9C","sourcesContent":[".btn-upload-box {\n    /*background-color: #b9a190;*/\n    background-color: #4a5568;\n    /* background-color: #e07a5f; /* Warm Coral */\n    /* background-color: #2b6cb0; /* Steel Blue */\n    color: #fff;\n    border: none;\n    padding: 8px 16px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    width: fit-content;\n    max-width: 250px;\n  }\n  \n  .btn-upload-box:hover {\n    /*background-color: #a48779;*/\n    background-color: #2d3748;\n    /* background-color: #c35c46; /* Darker Coral */\n   /*  background-color: #2c5282; /* Deep Blue */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
